/* Spanish presentation for the existing Recharge UI. Native nodes, values,
   selling plans, prices and event handlers stay owned by Recharge. */
(function () {
  'use strict';
  if (!/^es(?:-|$)/i.test(document.documentElement.lang)) return;

  var words = {
    'Cart': 'Carrito',
    'Remove': 'Eliminar',
    'Removing': 'Eliminando',
    'Current price': 'Precio actual',
    'Original price': 'Precio original',
    'Price after discount': 'Precio con descuento',
    'Your cart is empty!': '¡Tu carrito está vacío!',
    'Continue shopping': 'Seguir comprando',
    'Close': 'Cerrar',
    'Checkout': 'Finalizar compra',
    'Goes great with': 'Combina con',
    'Add': 'Agregar',
    'Adding...': 'Agregando...',
    'Previous product': 'Producto anterior',
    'Next product': 'Producto siguiente',
    'Decrease quantity': 'Reducir cantidad',
    'Increase quantity': 'Aumentar cantidad',
    'Quantity': 'Cantidad',
    'Deliver every': 'Entregar cada',
    'Deliver every:': 'Entregar cada:',
    'Purchase options': 'Opciones de compra',
    'One-time': 'Compra única',
    'One-time purchase': 'Compra única',
    'Subscribe & save': 'Suscríbete y ahorra',
    'Learn more': 'Más información',
    'Learn more about subscribe and save': 'Más información sobre suscribirte y ahorrar',
    'Original price strikethrough:': 'Precio original tachado:',
    ', Discounted price:': ', Precio con descuento:',
    'Spend': 'Agrega',
    'more for free shipping': 'más para obtener envío gratis',
    'Upgrading to subscription...': 'Cambiando a suscripción...',
    'Free shipping On Orders Over $100': 'Envío gratis en pedidos superiores a $100',
    '3-month minimum commitment. Cancel anytime after.': 'Compromiso mínimo de 3 meses. Después puedes cancelar en cualquier momento.',
    'Great reasons to subscribe': 'Ventajas de suscribirte',
    'Flexible frequency': 'Frecuencia flexible',
    'Not sure how much of something you need, or how often? Adjust quantities and frequencies any time.': '¿No sabes cuánto necesitas o con qué frecuencia? Ajusta las cantidades y la frecuencia en cualquier momento.',
    'Order reminders': 'Recordatorios de pedidos',
    "We'll let you know before each shipment. Delay, reschedule or cancel if you need to - we'll only bill you when your order ships.": 'Te avisaremos antes de cada envío. Si lo necesitas, retrasa, reprograma o cancela; solo te cobraremos cuando se envíe tu pedido.',
    "You're in control": 'Tú tienes el control',
    'Add or remove subscriptions, cancel orders, and edit frequencies and quantities through our user-friendly customer portal.': 'Agrega o elimina suscripciones, cancela pedidos y modifica la frecuencia y las cantidades desde nuestro portal de clientes.',
    'Got it': 'Entendido'
  };
  var units = {day: 'día', days: 'días', week: 'semana', weeks: 'semanas', month: 'mes', months: 'meses'};
  function translated(text) {
    var raw = text.trim(), key = raw.replace(/\s+/g, ' '), result = words[key], match;
    if (!result) {
      if ((match = /^Your cart \((\d+)\)$/.exec(key))) result = 'Tu carrito (' + match[1] + ')';
      else if ((match = /^Subtotal \((\d+) items?\):$/.exec(key))) result = 'Subtotal (' + match[1] + (match[1] === '1' ? ' artículo):' : ' artículos):');
      else if ((match = /^(Save up to|Save|save|Saving) (\d+(?:\.\d+)?%)$/.exec(key))) result = (match[1] === 'Save up to' ? 'Ahorra hasta ' : 'Ahorra ') + match[2];
      else if ((match = /^Upgrade to subscription and save up to (\d+(?:\.\d+)?%)$/.exec(key))) result = 'Suscríbete y ahorra hasta ' + match[1];
      else if ((match = /^(\d+) (day|days|week|weeks|month|months)(?: save (\d+(?:\.\d+)?%))?$/.exec(key))) result = match[1] + ' ' + units[match[2]] + (match[3] ? ' · ahorra ' + match[3] : '');
      else if ((match = /^(\d+) (day|days|week|weeks|month|months) subscription with (\d+(?:\.\d+)?%) discount$/.exec(key))) result = 'Suscripción cada ' + match[1] + ' ' + units[match[2]] + ' · ' + match[3] + ' de descuento';
      else if ((match = /^(Remove|Removing) (.+)$/.exec(key))) result = (match[1] === 'Remove' ? 'Eliminar ' : 'Eliminando ') + match[2];
      else if ((match = /^(Current price|Original price|Price after discount): (.+)$/.exec(key))) result = ({'Current price':'Precio actual','Original price':'Precio original','Price after discount':'Precio con descuento'})[match[1]] + ': ' + match[2];
    }
    return result ? text.replace(raw, result) : text;
  }

  var watched = new WeakSet();
  function localize(surface) {
    // Walk text nodes instead of rewriting HTML: retain Lit markers and handlers.
    var walker = document.createTreeWalker(surface, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var parent = node.parentElement;
      if (!parent || parent.closest('style, script, svg, textarea, [contenteditable]')) continue;
      // Unvalued native options can derive their value from text; leave those alone.
      if (parent.tagName === 'OPTION' && !parent.hasAttribute('value')) continue;
      var next = translated(node.nodeValue);
      if (next !== node.nodeValue) node.nodeValue = next;
    }
    surface.querySelectorAll('[aria-label], [title]').forEach(function (element) {
      ['aria-label', 'title'].forEach(function (attribute) {
        var value = element.getAttribute(attribute);
        if (value) {
          var next = translated(value);
          if (next !== value) element.setAttribute(attribute, next);
        }
      });
    });
    surface.querySelectorAll('*').forEach(function (element) {
      if (element.shadowRoot) connect(element.shadowRoot);
    });
  }
  function connect(surface) {
    if (!watched.has(surface)) {
      watched.add(surface);
      new MutationObserver(function () { localize(surface); }).observe(surface, {
        subtree: true, childList: true, characterData: true,
        attributes: true, attributeFilter: ['aria-label', 'title']
      });
    }
    localize(surface);
  }
  function discover() {
    document.querySelectorAll('recharge-subscription-widget, rc-learn-more-modal, #recharge-storefront-experiences__cart-drawer, #recharge-storefront-experiences__cart-overlay').forEach(function (host) {
      connect(host);
      if (host.shadowRoot) connect(host.shadowRoot);
    });
  }
  // Some app components attach a shadow root after their host enters the DOM.
  // Bounded startup retries cover that case; later remounts are observed normally.
  var attempts = 0;
  function startup() {
    discover();
    if (++attempts < 20) window.setTimeout(startup, 250);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startup, {once:true});
  else startup();
  new MutationObserver(discover).observe(document.documentElement, {childList:true, subtree:true});
})();
